import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import BodyView from "@/layout/BodyView.vue";
import BodySupportView from "@/layout/BodySupportView.vue";
import AuthView from "@/components/common/block/auth/AuthView.vue";
import LoginPage from "@/components/common/block/auth/LoginPage.vue";

import indexAddReceiptProduct from "@/pages/receipt-product/indexAddReceiptProduct.vue";
import indexAddDocumentPreparation from "@/pages/receipt-product/indexAddDocumentPreparation.vue";
import indexListStock from "@/pages/receipt-product/indexListStock.vue";
import indexListProduct from "@/pages/receipt-product/indexListProduct.vue";
import indexReceiptProductDetail from "@/pages/receipt-product/indexReceiptProductDetail.vue";
import indexDocumentPreparationDetail from "@/pages/receipt-product/indexDocumentPreparationDetail.vue";
import indexListPreparation from "@/pages/receipt-product/indexListPreparation.vue";
import indexListShipping from "@/pages/receipt-product/indexListShipping.vue";
import indexShipping from "@/pages/receipt-product/indexShipping.vue";
import indexListAnnualFee from "@/pages/annual-service-fee/indexListAnnualFee.vue";
import indexAddAnnualFee from "@/pages/annual-service-fee/indexAddAnnualFee.vue";
import indexListClouds from "@/pages/annual-service-fee/indexListClouds.vue";
import indexAnnualFeeDetail from "@/pages/annual-service-fee/indexAnnualFeeDetail.vue";
import indexListMA from "@/pages/ma/indexListMA.vue";
import indexDetailMA from "@/pages/ma/indexDetailMA.vue";
import indexAssessment from "@/pages/ma/indexAssessment.vue";
import indexListEquipments from "@/pages/ma/indexListEquipments.vue";
import indexDetailEquipment from "@/pages/ma/indexDetailEquipment.vue";
import indexProductPlanner from "@/pages/product-planner/indexProductPlanner.vue";
import indexProductPlannerList from "@/pages/product-planner/indexProductPlannerList.vue";
import indexChatSupports from "@/pages/supports/indexChatSupports.vue";
import indexHomeSupports from "@/pages/supports/indexHomeSupports.vue";
import indexListRepairRequest from "@/pages/repair-request/indexListRepairRequest.vue";
import indexAddRepairRequest from "@/pages/repair-request/indexAddRepairRequest.vue";
import indexDashboard from "@/pages/dashboard/DashboardView.vue";
import indexFormProduct from "@/pages/forms/indexFormProduct.vue";
import indexErrorPage1 from "@/pages/error/indexErrorPage1.vue";
import indexErrorPage2 from "@/pages/error/indexErrorPage2.vue";
import indexErrorPage3 from "@/pages/error/indexErrorPage3.vue";
import indexErrorPage4 from "@/pages/error/indexErrorPage4.vue";
import indexErrorPage5 from "@/pages/error/indexErrorPage5.vue";
import indexErrorPage6 from "@/pages/error/indexErrorPage6.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    redirect: "/receipt/list_stock",
  },
  {
    path: "/receipt",
    component: BodyView,
    children: [
      {
        path: "add_product_receipt",
        name: "addPorductReceipt",
        component: indexAddReceiptProduct,
        meta: {
          title: "เพิ่มสินค้านำเข้า",
        },
      },
      {
        path: "add_document_preparation",
        name: "addDocumentPreparation",
        component: indexAddDocumentPreparation,
        meta: {
          title: "เพิ่มรายการจัดของ",
        },
      },
      {
        path: "list_stock",
        name: "listStock",
        component: indexListStock,
        meta: {
          title: "คลังสินค้า",
          device_status: "สินค้าขาย"
        },
      },
      {
        path: "list_stock_defective",
        name: "listStockDefective",
        component: indexListStock,
        meta: {
          title: "เพิ่มรายการจัดของ",
          status: "ชำรุด"
        },
      },
      {
        path: "list_stock_back_up",
        name: "listStockBackUp",
        component: indexListStock,
        meta: {
          title: "เพิ่มรายการจัดของ",
          device_status: "เครื่องสำรอง"
        },
      },
      {
        path: "list_stock_demo",
        name: "listStockDemo",
        component: indexListStock,
        meta: {
          title: "เพิ่มรายการจัดของ",
          device_status: "เครื่อง Demo"
        },
      },
      {
        path: "list_product",
        name: "listProduct",
        component: indexListProduct,
        meta: {
          title: "สินค้าคงคลัง",
          device_status: "เครื่อง Demo"
        },
      },
      {
        path: "list_preparation",
        name: "listPreparation",
        component: indexListPreparation,
        meta: {
          title: "รายการจัดของ",
        },
      },
      {
        path: "list_shipping",
        name: "listShipping",
        component: indexListShipping,
        meta: {
          title: "ใบจัดส่งสินค้า",
        },
      },
      {
        path: "list_shipping/:id",
        name: "listShippingDetail",
        component: indexShipping,
        meta: {
          title: "ใบจัดส่งสินค้า",
        },
      },
      {
        path: "receipt_product_detail/:id",
        name: "receiptProductDetail",
        component: indexReceiptProductDetail,
        meta: {
          title: "เพิ่มสินค้านำเข้า",
        },
      },
      {
        path: "document_preparation_detail/:type/:id",
        name: "documentPreparationDetail",
        component: indexFormProduct,
        meta: {
          title: "ข้อมูลการจัดของ",
        },
      },
      {
        path: "product_planner_list",
        name: "productPlannerList",
        component: indexProductPlannerList,
        meta: {
          title: "รายการแพลนสินค้า",
        },
      },
      {
        path: "product_planner/:id?",
        name: "productPlanner",
        component: indexProductPlanner,
        meta: {
          title: "แพลนสินค้า",
        },
      },
    ],
  },
  {
    path: "/annual_service_fee",
    component: BodyView,
    children: [
      {
        path: "service_fee_list",
        name: "serviceFeeList",
        component: indexListAnnualFee,
        meta: {
          title: "รายการเก็บค่าบริการรายปี",
        },
      },
      {
        path: "service_fee_list_detail/:id",
        name: "serviceFeeListDetail",
        component: indexAnnualFeeDetail,
        meta: {
          title: "ข้อมูลเก็บค่าบริการรายปี",
        },
      },
      {
        path: "add_service_fee",
        name: "addServiceFee",
        component: indexAddAnnualFee,
        meta: {
          title: "เพิ่มรายการเก็บค่าบริการรายปี",
        },
      },
      {
        path: "clouds_list",
        name: "listClouds",
        component: indexListClouds,
        meta: {
          title: "รายชื่อระบบบริการรายปี",
        },
      },
    ],
  },
  {
    path: "/ma",
    component: BodyView,
    children: [
      {
        path: "detail_ma/:id?",
        name: "detailMA",
        component: indexDetailMA,
        meta: {
          title: "รายละเอียด MA",
        },
      },
      {
        path: "list_ma/:type?",
        name: "listMA",
        component: indexListMA,
        meta: {
          title: "รายการ MA ",
        },
      },
      {
        path: "equipments",
        name: "listEquipment",
        component: indexListEquipments,
        meta: {
          title: "รายการอุปกรณ์",
        },
      },
      {
        path: "equipment/:id?",
        name: "detailsEquipment",
        component: indexDetailEquipment,
        meta: {
          title: "รายละเอียดอุปกรณ์",
        },
      },
      {
        path: "assessment/:id?",
        name: "assessment",
        component: indexAssessment,
        meta: {
          title: "รายละเอียดการประเมิน",
        },
      },
    ],
  },
  {
    path: "/repair_request",
    component: BodyView,
    children: [
      {
        path: "detail_repair_request/:id?",
        name: "detailRepairRequest",
        component: indexListRepairRequest,
        meta: {
          title: "รายละเอียดรายการซ่อม",
        },
      },
      {
        path: "list_repair_request",
        name: "listRepairRequest",
        component: indexListRepairRequest,
        meta: {
          title: "รายการซ่อม",
        },
      },
      {
        path: "add_repair_request",
        name: "addRepairRequest",
        component: indexAddRepairRequest,
        meta: {
          title: "เพิ่มรายการซ่อม",
        },
      },
    ],
  },
  {
    path: "/auth",
    component: AuthView,
    children: [
      {
        path: "login",
        name: "login",
        component: LoginPage,
        meta: {
          title: "Login",
        },
      },
    ],
  },
  {
    path: "/support",
    component: BodySupportView,
    children: [
      {
        path: "",
        redirect: { name: "HomeSupport" },
      },
      {
        path: "home/:id?",
        name: "HomeSupport",
        component: indexHomeSupports,
      },
      {
        path: "chat",
        name: "ChatWindow",
        component: indexChatSupports,
      },
      {
        path: "add_repair_request_support",
        name: "addRepairRequestSupport",
        component: indexAddRepairRequest,
      },
    ],
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: indexDashboard,
    meta: {
      title: 'Dashboard | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/error_page1",
    name: "errorPage1",
    component: indexErrorPage1,
    meta: {
      title: 'Error Page1 | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/error_page2",
    name: "errorPage2",
    component: indexErrorPage2,
    meta: {
      title: 'Error Page2 | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/error_page3",
    name: "errorPage3",
    component: indexErrorPage3,
    meta: {
      title: 'Error Page3 | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/error_page4",
    name: "errorPage4",
    component: indexErrorPage4,
    meta: {
      title: 'Error Page4 | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/error_page5",
    name: "errorPage5",
    component: indexErrorPage5,
    meta: {
      title: 'Error Page5 | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/error_page6",
    name: "errorPage6",
    component: indexErrorPage6,
    meta: {
      title: 'Error Page6 | Mofi - Premium Vue Admin Template',
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  if (typeof to.meta.title === "string") {
    document.title = to.meta.title;
  }
  const path = ["/auth/login", "/auth/register", "/support", "/dashboard", "/support/home", "/support/chat", "/error_page1", "/error_page2", "/error_page3", "/error_page4", "/error_page5", "/error_page6"];
  if (
    path.includes(to.path) ||
    /^\/support\/home(\/[^\/]*)?$/.test(to.path) ||
    localStorage.getItem("user")
  ) {
    return next();
  }
  next("/auth/login");
});

export default router;
